import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { object, string, number, ValidationError } from "yup";
import DatePicker from "react-datepicker";
import moment from "moment";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import SelectComponent from "../Components/Common/SelectComponent";
import {
  useGetCitiesQuery,
  useGetIdentityQuery,
  useGetIndustriesQuery,
  useGetPhoneCodeQuery,
  useGetSkillsQuery,
  useUploadFileMutation,
} from "../Store/api/CommonApi";
import "react-datepicker/dist/react-datepicker.css";
import { useUpdateProfileMutation } from "../Store/api/AuthApi";
import Swal from "sweetalert2";
import InlineCheckboxComponent from "../Components/Common/InlineCheckboxComponent";
import AuthLayout from "../Layout/AuthLayout";
import { useSelector } from "react-redux";
import CurrencyInput from "react-currency-input-field";
import { RootState } from "../Store";

const emailRgx = new RegExp(
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

let ProfileSchema = object().shape({
  legal_name: string().required({ legal_name: "Legal Name is required." }),
  preferred_name: string().required({
    preferred_name: "Preferred/Chosen Name is required.",
  }),
  date_of_birth: string().required({
    date_of_birth: "Date of Birth is required.",
  }),
  identify_as: string().required({
    identify_as: "Identify as is required.",
  }),
  //   identify_as_other: string().required({
  //     identify_as: "Identify as is required.",
  //   }),
  interested_in_internships: string().required({
    interested_in_internships:
      "Interested in applying for Internships is required.",
  }),
  email: string()
    .email({ email: "Enter correct email." })
    .required({ email: "Email is required." })
    .matches(emailRgx, { message: { email: "Email is invalid." } }),
  alternate_email: string()
    .email({ alternate_email: "Enter correct email." })
    .required({ alternate_email: "Alternate Email is required." })
    .matches(emailRgx, {
      message: { alternate_email: "Alternate Email is invalid." },
    }),
  ph_country_code: string().required({
    ph_country_code: "Code is required.",
  }),
  phone_number: string().required({
    phone_number: "Mobile number is required.",
  }),
  wh_country_code: string().required({
    wh_country_code: "Whatsapp code is required.",
  }),
  whatsapp_number: string().required({
    whatsapp_number: "WhatsApp Number is required.",
  }),
  pronoun: string().required({
    pronoun: "Pronoun is required.",
  }),
  shared_with_circle_identity_as_lgbt: string().required({
    shared_with_circle_identity_as_lgbt: "Field is required.",
  }),
  current_profile_role: string().required({
    current_profile_role: "Current Job Role is required.",
  }),
  skills: string().required({ skills: "Key skills are required." }),
  industry: string().required({
    industry: "Industry Type are required.",
  }),
  total_experience_years: string().required({
    total_experience_years: "Experience year is required.",
  }),
  total_experience_months: string().required({
    total_experience_months: "Experience month is required.",
  }),
  current_location: string().required({
    current_location: "Location is required.",
  }),
  current_previous_company: string().required({
    current_previous_company: "Current/Previous company is required.",
  }),
  current_salary: string().required({
    current_salary: "Current/Last drawn Annual CTC is required.",
  }),
  annual_package: number().required({
    current_salary: "Select salary type.",
  }),
  about_yourself: string().required({
    about_yourself: "Tell us about yourself is required.",
  }),
  highest_education: string().required({
    highest_education: "Highest Education Qualification is required.",
  }),
  institution_name: string().required({
    institution_name: "Name of Educational Institution is required.",
  }),
  highest_education_passing_year: string().required({
    highest_education_passing_year:
      "Year of passing Highest Education is required.",
  }),
  highest_education_passing_month: string().required({
    highest_education_passing_month:
      "Month of passing Highest Education is required.",
  }),
  how_did_you_know: string().required({
    how_did_you_know: "How did you learn about us is required.",
  }),
  notice_period: string().required({
    notice_period: "Notice period is required.",
  }),
  expected_salary: string().required({
    expected_salary: "Please enter expected salary.",
  }),
  //   resume_file: string().required({
  //     resume_file: "Resume file is required.",
  //   }),
});

export default function EditProfile() {
  let optionCount = 50;

  const months = useMemo(() => {
    return {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December",
    };
  }, []);

  const profile = useSelector((state: RootState) => state.auth.profile);

  const identityRef = useRef();
  const locationRef = useRef();
  const skillsRef = useRef();
  const industryRef = useRef();

  const [profileInput, setProfileInput] = useState({
    ...profile,
    resume_file: "",
  });
  const [errors, setError] = useState({});

  const [locations, setLocations] = useState([]);
  const [Prelocations, setPreLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState({});
  const [selectedPrefferedLocations, setSelectedPrefferedLocations] = useState(
    {}
  );

  const [skills, setSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);

  const [identities, setIdentities] = useState([]);
  const [selectedIdentities, setSelectedIdentities] = useState({});
  const [candidateAge, setCandidateAge] = useState(0);

  const [industries, setIndustries] = useState([]);
  const [selectedIndustries, setSelectedIndustries] = useState({});

  const [internshipMonth, setIntershipMonth] = useState([]);

  const [phoneCodes, setPhoneCodes] = useState([]);

  const citiesApi = useGetCitiesQuery();
  const skillsApi = useGetSkillsQuery();
  const identityApi = useGetIdentityQuery();
  const industryApi = useGetIndustriesQuery();
  const [uploadFile] = useUploadFileMutation();
  const [updateProfile] = useUpdateProfileMutation();
  const phoneCodeApi = useGetPhoneCodeQuery();

  const formatOptionList = useCallback(
    (
      res,
      label,
      value,
      callback,
      selectedData = [],
      setStateFun = null,
      isMulti = false
    ) => {
      if (res.length > 0) {
        let optionArray = [];
        let selectedOptions = isMulti ? [] : {};
        res.forEach((obj, i) => {
          optionArray.push({ value: obj[value], label: obj[label] });
          if (
            selectedData &&
            setStateFun &&
            selectedData.includes(String(obj[value]))
          ) {
            if (!isMulti) {
              selectedOptions = { value: obj[value], label: obj[label] };
            } else {
              selectedOptions.push({ value: obj[value], label: obj[label] });
            }
          }
        });
        callback(optionArray);
        if (setStateFun) {
          setStateFun(selectedOptions);
        }
      }
    },
    []
  );

  useEffect(() => {
    if (citiesApi?.data && profileInput) {
      let locations = String(profileInput?.current_location).split(",");
      formatOptionList(
        citiesApi?.data?.data,
        "city_name",
        "id",
        setLocations,
        locations,
        setSelectedLocations
      );

      //console.log(profileInput?.prefered_location);

      let preferedLocation = String(profileInput?.prefered_location).split(",");
      formatOptionList(
        [
          {
            id: "",
            city_name: "Open for any Location",
          },
          ...citiesApi?.data?.data,
        ],
        "city_name",
        "id",
        setPreLocations,
        preferedLocation,
        setSelectedPrefferedLocations
      );
    }
  }, [
    citiesApi,
    setLocations,
    setPreLocations,
    formatOptionList,
    profileInput,
    setSelectedLocations,
  ]);

  useEffect(() => {
    if (phoneCodeApi.data?.data.length > 0) {
      setPhoneCodes(phoneCodeApi.data?.data);
    }
  }, [phoneCodeApi?.data, setPhoneCodes]);

  useEffect(() => {
    if (skillsApi?.data && profileInput) {
      let skillsArray = String(profileInput?.skills).split(",");
      formatOptionList(
        skillsApi?.data?.data,
        "skill_title",
        "id",
        setSkills,
        skillsArray,
        setSelectedSkills,
        true
      );
    }
  }, [skillsApi, setSkills, formatOptionList, profileInput, setSelectedSkills]);

  console.log(selectedIndustries);
  



  useEffect(() => {
    if (identityApi?.data && profileInput) {
      let identities = String(profileInput?.identify_as).split(",");
      let ids = identityApi?.data?.data;
      if (ids && ids.length > 0) {
        formatOptionList(
          identityApi?.data?.data,
          "identify_name",
          "id",
          setIdentities,
          identities,
          setSelectedIdentities
        );
      }
    }
  }, [
    identityApi,
    setIdentities,
    formatOptionList,
    profileInput,
    setSelectedIdentities,
  ]);

  useEffect(() => {
    if (industryApi?.data && profileInput) {
      let industries = String(profileInput?.industry).split(",");
      formatOptionList(
        industryApi?.data?.data,
        "industrial_area",
        "id",
        setIndustries,
        industries,
        setSelectedIndustries
      );
    }
  }, [
    industryApi,
    setIndustries,
    formatOptionList,
    profileInput,
    setSelectedIndustries,
  ]);

  useEffect(() => {
    if (document.getElementById("default-select")) {
      window.$("default-select").niceSelect();
    }
  }, []);

  useEffect(() => {
    if (profile?.internship_available_months !== undefined) {
      const internshipMonts = String(
        profile?.internship_available_months
      ).split(",");
      if (internshipMonts.length > 0) {
        let i = 0;
        for (i; i < internshipMonts.length; i++) {
          if (document.getElementById("lbl_" + internshipMonts[i]) !== null) {
            document.getElementById("lbl_" + internshipMonts[i]).checked = true;
          }
        }
        setIntershipMonth(internshipMonts);
      }
    }
  }, [profile]);

  const calulatAge = useCallback(
    (dob) => {
      var years = Math.floor(moment().diff(dob, "years", true));
      setCandidateAge(years);
    },
    [setCandidateAge]
  );

  useEffect(() => {
    if (profileInput?.date_of_birth) {
      calulatAge(profileInput?.date_of_birth);
    }
  }, [profileInput?.date_of_birth, calulatAge]);

  const handleSelect = useCallback(
    (values, inputname) => {
      if (values?.length > 0) {
        let ids = [];
        values.forEach((element, i) => {
          ids.push(element?.value);
        });
        setProfileInput({
          ...profileInput,
          [inputname]: ids.toString(),
        });
      } else if (values?.value) {
        setProfileInput({
          ...profileInput,
          [inputname]: values.value.toString(),
        });
      }
    },
    [profileInput, setProfileInput]
  );

  const handleUpdate = useCallback(
    (e) => {
      e.preventDefault();
      ProfileSchema.validate(profileInput, { strict: false, abortEarly: false })
        .then((resp) => {
          if (resp?.identify_as === "11" && resp?.identify_as_other === "") {
            setError({ identify_as_other: "Enter your identity." });
            return false;
          }

          if (resp?.pronoun === "Other" && resp?.pronoun_as_other === "") {
            setError({ pronoun_as_other: "Enter your pronoun." });
            return false;
          }

          if (
            resp?.shared_with_circle_identity_as_lgbt === 1 &&
            resp?.shared_with_circle_identity_as_lgbt_reson === ""
          ) {
            setError({
              shared_with_circle_identity_as_lgbt_reson:
                "Please select the option from list.",
            });
            return false;
          }

          if (resp?.interested_in_internships === 1) {
            if (resp?.over_eighteen_years === "") {
              setError({ over_eighteen_years: "Select option from the list." });
            }
            if (resp?.internship_available_months === "") {
              setError({
                internship_available_months: "Select internship month.",
              });
            }
            if (resp?.aggregate_percentage === "" && resp?.cgpa === "") {
              setError({
                aggregate_percentage:
                  "Select aggregate percentage from the list OR enter CGPA",
              });
            }
            return false;
          }

          let selectedSkills = resp?.skills;
          let skillsArray = selectedSkills.split(",");
          if (skillsArray.length < 5) {
            setError({
              skills: "Please select at least 5 skills.",
            });
            return false;
          }

          resp = {
            ...resp,
            date_of_birth: moment(resp?.date_of_birth).format("yyyy-MM-DD"),
            shared_with_circle_identity_as_lgbt: Number(
              resp?.shared_with_circle_identity_as_lgbt
            ),
          };
          setError({});
          updateProfile(resp)
            .then((response) => {
              if (response?.data?.message) {
                Swal.fire({
                  title: "Success!",
                  text: response?.data?.message,
                  icon: "success",
                });
              } else {
                Swal.fire({
                  title: "Error!",
                  text: response?.error?.data?.error,
                  icon: "error",
                });
              }
            })
            .catch((e) => console.log(e));
        })
        .catch((err) => {
          let errObj = {};

          err.errors.map((msg, i) => {
            let keys = Object.keys(msg);
            if (errObj[keys[0]] === undefined) {
              errObj = { ...errObj, [keys[0]]: msg[keys[0]] };
            }
            return false;
          });
          setError(errObj);
        });
    },
    [profileInput, updateProfile]
  );

  const selectOptions = useCallback(() => {
    let options = [];
    for (let index = 0; index < optionCount; index++) {
      options.push(
        <option value={index} key={index}>
          {index}
        </option>
      );
    }
    return options;
  }, [optionCount]);

  const selectYearsOptions = useCallback(() => {
    let options = [];
    for (let index = Number(moment().year()); index >= 1960; index--) {
      options.push(
        <option value={index} key={index}>
          {index}
        </option>
      );
    }
    return options;
  }, []);

  const handleUploadImage = useCallback(
    (file) => {
      var filePath = file.name;
      var allowedExtensions = /(\.pdf|\.doc|\.docx)$/i;
      if (!allowedExtensions.exec(filePath)) {
        //error("Please upload file having extensions .pdf/.doc/.docx only.");
        Swal.fire({
          title: "Error!",
          text: "Please upload file having extensions .pdf/.doc/.docx only.",
          icon: "error",
        });
        return false;
      }
      uploadFile(file)
        .then((res) => {
          if (res.data?.data) {
            setProfileInput({
              ...profileInput,
              resume_file: res.data?.data,
            });
          } else {
            console.log(res.data?.error);
          }
        })
        .catch((err) => console.log(err));
    },
    [profileInput, setProfileInput, uploadFile]
  );

  const OnCheck = useCallback(
    (value, isChecked) => {
      let newMonths = [];
      if (isChecked) {
        newMonths = [...internshipMonth, value];
        setIntershipMonth(newMonths);
      } else {
        newMonths = internshipMonth.filter(function (v) {
          return v !== value;
        });
        setIntershipMonth(newMonths);
      }
      newMonths = newMonths.sort((a, b) => Number(a) - Number(b));
      setProfileInput({
        ...profileInput,
        internship_available_months: newMonths.toString(),
      });
    },
    [internshipMonth, profileInput, setProfileInput]
  );

  const onCheckAll = useCallback(
    (value, isChecked) => {
      let upMonths = [];
      let list = document.getElementsByClassName("internship-months");
      let i = 0;
      if (isChecked) {
        for (i = 0; i < list.length; i++) {
          document.getElementsByClassName("internship-months")[
            i
          ].checked = true;
        }
        upMonths = Object.keys(months);
        setIntershipMonth(upMonths);
      } else {
        for (i = 0; i < list.length; i++) {
          document.getElementsByClassName("internship-months")[
            i
          ].checked = false;
        }
        setIntershipMonth(upMonths);
      }
      setProfileInput({
        ...profileInput,
        internship_available_months: upMonths.toString(),
      });
    },
    [setIntershipMonth, setProfileInput, profileInput, months]
  );

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      let errorHtml = Object.keys(errors).map((k, i) => {
        return `<li>${errors[k]}</li>`;
      });

      Swal.fire({
        icon: "error",
        title: "Input validation error!",
        html: "<ul>" + errorHtml.join("") + "</ul>",
      });
    }
  }, [errors]);

  return (
    <Fragment>
      <PageBannerComponent title="Edit Profile" />
      <AuthLayout>
        <div className="inner-box my-resume">
          <form className="form-area" onSubmit={handleUpdate}>
            <div className="row">
              <div className="col-lg-12 form-group">
                <div className="form-group">
                  <label htmlFor="Upload" className="">
                    <span style={{ color: "red" }}>*</span>Please Upload Your
                    Resume
                  </label>
                  <input
                    className="p-0 form-control border-0"
                    accept=".doc,.docx,.pdf"
                    type="file"
                    onChange={(e) => handleUploadImage(e.target.files[0])}
                  />
                  {errors?.resume_file !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.resume_file}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="first_name">
                    <span style={{ color: "red" }}>*</span>Legal Name <br />
                    <sub>
                      (As per Govt. ID, For example, Aadhar Card, Driving
                      License etc.)
                    </sub>
                  </label>
                  <input
                    name="name"
                    placeholder="Legal Name"
                    //onFocus="this.placeholder = ''"
                    //onBlur="this.placeholder = 'Enter your name'"
                    className="common-input form-control"
                    required=""
                    type="text"
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        legal_name: e.target.value,
                      })
                    }
                    defaultValue={profileInput?.legal_name}
                  />
                  {errors?.legal_name !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.legal_name}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="Preferred/Chosen Name">
                    <span style={{ color: "red" }}>*</span>Preferred/Chosen Name{" "}
                    <br />
                    {/* <sub>(Preferred/Chosen Name)</sub> */}
                  </label>
                  <input
                    placeholder="Preferred Name"
                    //onFocus="this.placeholder = ''"
                    //onBlur="this.placeholder = 'Enter email address'"
                    className="common-input form-control"
                    required=""
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        preferred_name: e.target.value,
                      })
                    }
                    defaultValue={profileInput?.preferred_name}
                  />
                  {errors?.preferred_name !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.preferred_name}
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="DOB">
                        <span style={{ color: "red" }}>*</span>Date of Birth
                        <br />
                        {/* <sub>(DD/MM/YY)</sub> */}
                      </label>
                      <div>
                        <DatePicker
                          selected={
                            profileInput?.date_of_birth === "0000-00-00"
                              ? ""
                              : new Date(profileInput?.date_of_birth)
                          }
                          onChange={(date) =>
                            setProfileInput({
                              ...profileInput,
                              date_of_birth: date,
                            })
                          }
                          showIcon
                          className="form-control common-input px-5 py-2"
                          //dateFormat="Y-MM-dd"
                          maxDate={new Date()}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                        />
                      </div>
                      {errors?.date_of_birth !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.date_of_birth}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="Age">
                        Age
                        <br />
                      </label>
                      <input
                        placeholder="Age"
                        className="common-input form-control"
                        //defaultValue={candidateAge + " Years"}
                        value={candidateAge + " Years"}
                        readOnly={true}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="Identify">
                    <span style={{ color: "red" }}>*</span>Identify as <br />
                    <sub>
                      (We at Pride Circle specialize in hiring LGBT+ talent
                      only)
                    </sub>
                  </label>
                  {/* <div className="form-select">
                        <select
                          onChange={(e) => {
                           console.log('asdsd');
                           
                            setProfileInput({
                              ...profileInput,
                              identify_as: e.target.value,
                            });
                          }}
                        >
                          <option value="" hidden="">
                            Identify as
                          </option>
                          {identities.map((identity, i) => (
                            <option value={identity?.id} key={i}>
                              {identity?.identify_name}
                            </option>
                          ))}
                        </select> 
                      </div>*/}
                  <SelectComponent
                    //multiple={true}
                    options={identities}
                    onValueSelect={handleSelect}
                    name="identify_as"
                    selected={selectedIdentities}
                    selectRef={identityRef}
                    create={false}
                  />
                  {errors?.identify_as !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.identify_as}
                    </div>
                  )}
                </div>

                {Number(profileInput?.identify_as) === 11 && (
                  <div className="form-group">
                    <input
                      className="form-control mt-10"
                      type="text"
                      placeholder="Enter your custom identity"
                      onChange={(e) =>
                        setProfileInput({
                          ...profileInput,
                          identify_as_other: e.target.value,
                        })
                      }
                      defaultValue={profileInput?.identify_as_other}
                    />
                    {errors?.identify_as_other !== undefined && (
                      <div className="invalid-feedback d-block">
                        {errors?.identify_as_other}
                      </div>
                    )}
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="Internships" className="">
                    <span style={{ color: "red" }}>*</span>Are you interested in
                    applying for Internships?
                    <br />
                    <sub>(Only students may apply for Internships)</sub>
                  </label>

                  <select
                    className="form-control"
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        interested_in_internships: Number(e.target.value),
                      })
                    }
                    defaultValue={profileInput?.interested_in_internships}
                  >
                    <option value="" hidden>
                      Choose Options
                    </option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                  {errors?.interested_in_internships !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.interested_in_internships}
                    </div>
                  )}
                </div>
                {profileInput?.interested_in_internships === 1 && (
                  <>
                    <div className="form-group">
                      <label htmlFor="Internships" className="">
                        <span style={{ color: "red" }}>*</span>Are you over 18
                        years of age?
                        <br />
                        <sub>
                          (If you are under 18 years of age, you are not
                          eligible to apply at this time and must select 'No'.
                          We encourage you to reapply once you meet the age
                          requirement.)
                        </sub>
                      </label>

                      <select
                        className="form-control"
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            over_eighteen_years: Number(e.target.value),
                          })
                        }
                        defaultValue={profileInput?.over_eighteen_years}
                      >
                        <option value="" hidden>
                          Choose Options
                        </option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                      {errors?.over_eighteen_years !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.over_eighteen_years}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="Internships" className="">
                        <span style={{ color: "red" }}>*</span>Available
                        month(s) for internship
                        <br />
                        <sub>(Select all that apply for the year)</sub>
                      </label>
                      <div className="row">
                        {Object.keys(months).map((month, i) => (
                          <InlineCheckboxComponent
                            label={months[month]}
                            value={month}
                            onCheck={function (e) {
                              OnCheck(e.target.value, e.target.checked);
                            }}
                            key={i}
                          />
                        ))}
                        <InlineCheckboxComponent
                          label="Select All"
                          value={""}
                          onCheck={function (e) {
                            onCheckAll(e.target.value, e.target.checked);
                          }}
                        />
                      </div>

                      {errors?.internship_available_months !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.internship_available_months}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="Internships" className="">
                        <span style={{ color: "red" }}>*</span>Aggregate
                        percentage obtained in highest/current educational
                        qualification
                        <br />
                        <sub>
                          (Please select only the range which would include your
                          aggregate percentage. If you obtained grades/credits,
                          convert them to percentage before selection.
                          Percentage to be calculated from 100%)
                        </sub>
                      </label>

                      <div className="row">
                        <div className="col-md-6">
                          <select
                            className="form-control"
                            onChange={(e) =>
                              setProfileInput({
                                ...profileInput,
                                aggregate_percentage: e.target.value,
                                cgpa: "",
                              })
                            }
                            defaultValue={profileInput?.aggregate_percentage}
                          >
                            <option value="">Choose Options</option>
                            <option value="Upto 50.00%">Upto 50.00%</option>
                            <option value="50.01 to 60.00%">
                              50.01 to 60.00%
                            </option>
                            <option value="60.01 to 70.00%">
                              60.01 to 70.00%
                            </option>
                            <option value="70.01 to 80.00%">
                              70.01 to 80.00%
                            </option>
                            <option value="80.01 to 90.00%">
                              80.01 to 90.00%
                            </option>
                            <option value="90.01 to 100.00%">
                              90.01 to 100.00%
                            </option>
                          </select>
                        </div>
                        <div className="col-md-1 d-flex justify-content-center align-items-center">
                          <h4>OR</h4>
                        </div>
                        <div className="col-md-5">
                          <input
                            placeholder="CGPA"
                            //onFocus="this.placeholder = ''"
                            //onBlur="this.placeholder = 'Enter your name'"
                            className="common-input form-control"
                            required=""
                            type="number"
                            onChange={(e) =>
                              setProfileInput({
                                ...profileInput,
                                cgpa: e.target.value,
                              })
                            }
                            readOnly={profileInput?.aggregate_percentage !== ""}
                            value={profileInput?.cgpa}
                            defaultValue={profileInput?.cgpa}
                          />
                        </div>
                      </div>
                      {errors?.aggregate_percentage !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.aggregate_percentage}
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="Email" className="">
                        <span style={{ color: "red" }}>*</span>Email <br />
                        <sub>
                          (Make sure you provide your active/personal email ID,
                          which will be used by Pride Circle and our Inclusive
                          Recruitment Partner Companies' to contact you)
                        </sub>
                      </label>
                      <input
                        placeholder="email"
                        //onFocus="this.placeholder = ''"
                        //onBlur="this.placeholder = 'Enter your name'"
                        className="common-input form-control"
                        required=""
                        type="email"
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            email: e.target.value,
                          })
                        }
                        defaultValue={profileInput?.email}
                      />
                      {errors?.email !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.email}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="Alternate Email" className="">
                        <span style={{ color: "red" }}>*</span>Alternate Email{" "}
                        <br />
                        <sub>
                          <br />
                          <br />
                          <br />
                        </sub>
                      </label>
                      <input
                        placeholder="Alternate Email"
                        //onFocus="this.placeholder = ''"
                        //onBlur="this.placeholder = 'Enter your name'"
                        className="common-input form-control"
                        required=""
                        type="email"
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            alternate_email: e.target.value,
                          })
                        }
                        defaultValue={profileInput?.alternate_email}
                      />
                      {errors?.alternate_email !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.alternate_email}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="Mobile" className="">
                        <span style={{ color: "red" }}>*</span>Mobile Number
                      </label>
                      <div className="row">
                        <div className="col-lg-3 pr-0">
                          <select
                            onChange={(e) =>
                              setProfileInput({
                                ...profileInput,
                                ph_country_code: e.target.value,
                              })
                            }
                            className="form-control p-0"
                            style={{ display: "inline-block" }}
                            //defaultValue={profileInput?.ph_country_code}
                            value={profileInput?.ph_country_code}
                          >
                            <option value="">Code</option>
                            {phoneCodes.length > 0 &&
                              phoneCodes.map((code, i) => {
                                return (
                                  <option value={"+" + code.phonecode} key={i}>
                                    {code.name +
                                      " " +
                                      "(+" +
                                      code.phonecode +
                                      ")"}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        <div className="col-lg-9">
                          <input
                            name="number"
                            placeholder="Mobile Number"
                            onChange={(e) =>
                              setProfileInput({
                                ...profileInput,
                                phone_number: e.target.value,
                              })
                            }
                            //onFocus="this.placeholder = ''"
                            //onBlur="this.placeholder = 'Mobile Number'"
                            className="common-input form-control"
                            defaultValue={profileInput?.phone_number}
                          />
                        </div>
                      </div>
                      {errors?.ph_country_code !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.ph_country_code}
                        </div>
                      )}
                      {errors?.phone_number !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.phone_number}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="WhatsApp" className="">
                        <span style={{ color: "red" }}>*</span>WhatsApp Number
                      </label>
                      <div className="row">
                        <div className="col-lg-3 pr-0">
                          <select
                            onChange={(e) =>
                              setProfileInput({
                                ...profileInput,
                                wh_country_code: e.target.value,
                              })
                            }
                            className="form-control p-0"
                            style={{ display: "inline-block" }}
                            //defaultValue={phoneCodes.length > 0 ? profileInput?.wh_country_code : profileInput?.wh_country_code}
                            value={profileInput?.wh_country_code}
                          >
                            <option value="" hidden="">
                              Code
                            </option>
                            {phoneCodes.length > 0 &&
                              phoneCodes.map((code, i) => {
                                return (
                                  <option value={"+" + code.phonecode} key={i}>
                                    {code.name +
                                      " " +
                                      "(+" +
                                      code.phonecode +
                                      ")"}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        <div className="col-lg-9">
                          <input
                            name="number"
                            placeholder="WhatsApp Number"
                            //onFocus="this.placeholder = ''"
                            //onBlur="this.placeholder = 'WhatsApp Number'"
                            className="common-input form-control"
                            required=""
                            type="text"
                            onChange={(e) =>
                              setProfileInput({
                                ...profileInput,
                                whatsapp_number: e.target.value,
                              })
                            }
                            defaultValue={profileInput?.whatsapp_number}
                          />
                        </div>
                      </div>
                      {errors?.wh_country_code !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.wh_country_code}
                        </div>
                      )}
                      {errors?.whatsapp_number !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.whatsapp_number}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="Pronoun">
                    <span style={{ color: "red" }}>*</span>Pronoun
                  </label>
                  <div className="form-select" id="default-select">
                    <select
                      onChange={(e) =>
                        setProfileInput({
                          ...profileInput,
                          pronoun: e.target.value,
                        })
                      }
                      className="form-control"
                      defaultValue={profileInput?.pronoun}
                    >
                      <option value="" hidden="">
                        Pronoun
                      </option>
                      <option value="She/Her">She/Her</option>
                      <option value="He/Him">He/Him</option>
                      <option value="They/Them">They/Them</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  {errors?.pronoun !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.pronoun}
                    </div>
                  )}
                </div>

                {profileInput?.pronoun === "Other" && (
                  <div className="form-group">
                    <input
                      className="form-control mt-10"
                      type="text"
                      placeholder="Enter your custom pronoun"
                      onChange={(e) =>
                        setProfileInput({
                          ...profileInput,
                          pronoun_as_other: e.target.value,
                        })
                      }
                      defaultValue={profileInput?.pronoun_as_other}
                    />
                    {errors?.pronoun_as_other !== undefined && (
                      <div className="invalid-feedback d-block">
                        {errors?.pronoun_as_other}
                      </div>
                    )}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="first_name" className="">
                    <span style={{ color: "red" }}>*</span> Have you shared your
                    LGBT+ identity with your circle/network? (Are you "Out"?) If
                    yes, please choose from the options below
                    <br />
                    <sub>
                      (If you're an employee, let us know if you're OUT at your
                      workplace. If you're a student, share if you're OUT in
                      your educational institution.)
                    </sub>
                  </label>

                  <select
                    className="form-control"
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        shared_with_circle_identity_as_lgbt:
                          e.target.value === "1"
                            ? Number(1)
                            : e.target.value === "0"
                            ? Number(0)
                            : "",
                        shared_with_circle_identity_as_lgbt_reson: "",
                      })
                    }
                    defaultValue={
                      profileInput?.shared_with_circle_identity_as_lgbt
                    }
                  >
                    <option value="" hidden>
                      Choose Options
                    </option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>

                  {errors?.shared_with_circle_identity_as_lgbt !==
                    undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.shared_with_circle_identity_as_lgbt}
                    </div>
                  )}
                </div>

                {profileInput?.shared_with_circle_identity_as_lgbt === 1 && (
                  <div className="form-group">
                    <label
                      htmlFor="shared_with_circle_identity_as_lgbt_reson"
                      className=""
                    >
                      <span style={{ color: "red" }}>*</span>If yes, please
                      choose from the options below:
                      <br />
                      <sub>
                        (If you're an employee, let us know if you're "OUT" at
                        your workplace. If you're a student, share if you're
                        "OUT" in your educational institution.)
                      </sub>
                    </label>

                    <select
                      className="form-control"
                      onChange={(e) =>
                        setProfileInput({
                          ...profileInput,
                          shared_with_circle_identity_as_lgbt_reson:
                            e.target.value,
                        })
                      }
                      defaultValue={
                        profileInput?.shared_with_circle_identity_as_lgbt_reson
                      }
                    >
                      <option value="">Choose Options</option>
                      <option value="1">At the workplace</option>
                      <option value="2">Friends</option>
                      <option value="3">Family</option>
                      <option value="4">Educational Institution</option>
                    </select>
                    {errors?.shared_with_circle_identity_as_lgbt_reson !==
                      undefined && (
                      <div className="invalid-feedback d-block">
                        {errors?.shared_with_circle_identity_as_lgbt_reson}
                      </div>
                    )}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="Current Job Role" className="">
                    <span style={{ color: "red" }}>*</span>Current Job Role{" "}
                    <br />
                    <sub>
                      (For example: Manager - Sales, Graphic Designer etc.)
                    </sub>
                  </label>
                  <input
                    name="name"
                    placeholder="Current Job Role"
                    //onFocus="this.placeholder = ''"
                    //onBlur="this.placeholder = 'Current Job Role'"
                    className="common-input form-control"
                    required=""
                    type="text"
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        current_profile_role: e.target.value,
                      })
                    }
                    defaultValue={profileInput?.current_profile_role}
                  />
                  {errors?.current_profile_role !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.current_profile_role}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="Key skills">
                    <span style={{ color: "red" }}>*</span>Key skills <br />
                    <sub>
                      (Please select a minimum of 5 Skills which are relevant to
                      your Job Role.)
                    </sub>
                  </label>

                  <SelectComponent
                    multiple={true}
                    selected={selectedSkills}
                    options={skills}
                    onValueSelect={handleSelect}
                    name="skills"
                    label="skill_title"
                    selectRef={skillsRef}
                  />
                  {errors?.skills !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.skills}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="Key skills" className="">
                    <span style={{ color: "red" }}>*</span>Industry Type
                    <br />
                  </label>
                  

                  <SelectComponent
                    //multiple={true}
                    options={industries}
                    onValueSelect={handleSelect}
                    name="industry"
                    selected={selectedIndustries}
                    selectRef={industryRef}
                    create={false}
                  />
                  {errors?.industry !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.industry}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="Experience" className="">
                    <span style={{ color: "red" }}>*</span>Total Years of
                    Experience
                    <br />
                    <sub>
                      (If you are a student with limited or no experience,
                      please enter 0 where applicable.)
                    </sub>
                  </label>
                  <div className="row">
                    <div
                      className="col-lg-6"
                      style={{ display: "inline-block" }}
                    >
                      <select
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            total_experience_years: Number(e.target.value),
                          })
                        }
                        id="experience_years"
                        className="form-select form-control"
                        name="experience_years"
                        defaultValue={profileInput?.total_experience_years}
                      >
                        <option value="">Years</option>
                        {selectOptions()}
                      </select>
                      {errors?.total_experience_years !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.total_experience_years}
                        </div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <select
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            total_experience_months: Number(e.target.value),
                          })
                        }
                        id="experience_months"
                        className="form-select form-control"
                        name="experience_months"
                        defaultValue={profileInput?.total_experience_months}
                      >
                        <option value="" hidden>
                          Months
                        </option>
                        <option value={0}>0</option>
                        <option value={1}>1</option>
                        <option value={2}>2</option>
                        <option value={3}>3</option>
                        <option value={4}>4</option>
                        <option value={5}>5</option>
                        <option value={6}>6</option>
                        <option value={7}>7</option>
                        <option value={8}>8</option>
                        <option value={9}>9</option>
                        <option value={10}>10</option>
                        <option value={11}>11</option>
                      </select>
                      {errors?.total_experience_months !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.total_experience_months}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="Location" className="">
                        <span style={{ color: "red" }}>*</span>Current Location
                      </label>
                      <SelectComponent
                        //multiple={true}
                        selected={selectedLocations}
                        options={locations}
                        onValueSelect={handleSelect}
                        name="current_location"
                        selectRef={locationRef}
                        create={false}
                      />
                      {errors?.current_location !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.current_location}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="Location" className="">
                        Preferred
                        Location
                      </label>
                      <SelectComponent
                        //multiple={true}
                        selected={
                          profileInput?.prefered_location > 0
                            ? selectedPrefferedLocations
                            : {
                                value: "",
                                label: "Open for any Location",
                              }
                        }
                        options={Prelocations}
                        onValueSelect={handleSelect}
                        name="prefered_location"
                        selectRef={locationRef}
                        create={false}
                      />
                      {errors?.prefered_location !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.prefered_location}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="form-group">
                  <label htmlFor="Location" className="">
                    <span style={{ color: "red" }}>*</span>Current Location
                  </label>
                  <SelectComponent
                    //multiple={true}
                    selected={selectedLocations}
                    options={locations}
                    onValueSelect={handleSelect}
                    name="current_location"
                    selectRef={locationRef}
                    create={false}
                  />
                  {errors?.current_location !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.current_location}
                    </div>
                  )}
                </div> */}
                <div className="form-group">
                  <label htmlFor="company" className="">
                    <span style={{ color: "red" }}>*</span>Current/Previous
                    company
                    <br />
                    <sub>
                      (If you have no work or internship experience, please
                      enter N/A in the field below.)
                    </sub>
                  </label>
                  <input
                    name="name"
                    placeholder="Current/Previous company"
                    //onFocus="this.placeholder = ''"
                    //onBlur="this.placeholder = 'Current/Previous company'"
                    className="common-input form-control"
                    required=""
                    type="text"
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        current_previous_company: e.target.value,
                      })
                    }
                    defaultValue={profileInput?.current_previous_company}
                  />
                  {errors?.current_previous_company !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.current_previous_company}
                    </div>
                  )}
                </div>
                {/* <div className="form-group">
                  <label htmlFor="salary">
                    <span style={{ color: "red" }}>*</span>Current/ Last drawn
                    Annual CTC (In INR) <br />
                    <sub>
                      (If you are a student with limited or no experience,
                      please enter 0 where applicable.)
                    </sub>
                  </label>
                  <div className="input-group">
                    <div>
                      <select
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            annual_package: Number(e.target.value),
                            current_salary:
                              Number(e.target.value) === 0 ? "NA" : "",
                          })
                        }
                        id="experience_months"
                        className="form-select form-control"
                        defaultValue={profileInput?.annual_package}
                      >
                        <option value={1}>Annual</option>
                        <option value={0}>Not Applicable</option>
                      </select>
                      {errors?.annual_package !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.annual_package}
                        </div>
                      )}
                    </div>
                    <div className="p-0 m-0 col">
                      <CurrencyInput
                        className="form-control"
                        placeholder="Annual CTC (In INR)"
                        onValueChange={(value, name, values) => {
                          setProfileInput({
                            ...profileInput,
                            current_salary: values?.value,
                          });
                        }}
                        value={
                          profileInput?.current_salary === "NA"
                            ? ""
                            : profileInput?.current_salary
                        }
                        readOnly={profileInput?.annual_package === 0}
                        intlConfig={{ locale: "en-IN", currency: "INR" }}
                        defaultValue={profileInput?.current_salary}
                      />
                      {errors?.current_salary !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.current_salary}
                        </div>
                      )}
                    </div>
                  </div>
                </div> */}

                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="salary">
                        <span style={{ color: "red" }}>*</span>Current / Last
                        drawn Annual CTC (In INR)
                        <br />
                        <sub>
                          (If you are a student with limited or no experience,
                          please enter 0 where applicable.)
                        </sub>
                      </label>
                      <div className="input-group">
                        <div>
                          <select
                            onChange={(e) =>
                              setProfileInput({
                                ...profileInput,
                                annual_package: Number(e.target.value),
                                current_salary:
                                  Number(e.target.value) === 0 ? 0 : "",
                              })
                            }
                            id="experience_months"
                            className="form-select form-control"
                            defaultValue={profileInput?.annual_package}
                          >
                            <option value={1}>Annual</option>
                            <option value={0}>Not Applicable</option>
                          </select>
                          {errors?.annual_package !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.annual_package}
                            </div>
                          )}
                        </div>

                        <div className="p-0 m-0 col">
                          <CurrencyInput
                            className="form-control"
                            placeholder="Annual CTC (In INR)"
                            onValueChange={(value, name, values) => {
                              setProfileInput({
                                ...profileInput,
                                current_salary: values?.value,
                              });
                            }}
                            value={
                              profileInput?.current_salary === 0
                                ? 0
                                : profileInput?.current_salary
                            }
                            readOnly={profileInput?.annual_package === 0}
                            intlConfig={{ locale: "en-IN", currency: "INR" }}
                            defaultValue={profileInput?.current_salary}
                          />
                          {errors?.current_salary !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.current_salary}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="salary">
                        <span style={{ color: "red" }}>*</span>Expected Salary{" "}
                        <br />
                        <br />
                        <sub></sub>
                        <br />
                      </label>
                      <div className="row">
                        <div className="col-md-8">
                          <div className="input-group">
                            <div className="p-0 m-0 col">
                              <CurrencyInput
                                className="form-control"
                                placeholder="Expected Salary (In INR)"
                                onValueChange={(value, name, values) => {
                                  setProfileInput({
                                    ...profileInput,
                                    expected_salary: values?.value,
                                  });
                                }}
                                value={profileInput?.expected_salary}
                                intlConfig={{
                                  locale: "en-IN",
                                  currency: "INR",
                                }}
                                defaultValue={profileInput?.expected_salary}
                              />
                              {errors?.expected_salary !== undefined && (
                                <div className="invalid-feedback d-block">
                                  {errors?.expected_salary}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 p-0">
                          <label htmlFor="negotiable">
                            <input
                              type="checkbox"
                              id="negotiable"
                              defaultChecked={profileInput?.negotiable}
                              onChange={(e) => {
                                setProfileInput({
                                  ...profileInput,
                                  negotiable: e.target.checked ? 1 : 0,
                                });
                              }}
                            />
                            {" Negotiable ?"}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="notice_period" className="">
                    <span style={{ color: "red" }}>*</span>Notice Period <br />
                    <sub>(Notice period in days)</sub>
                  </label>
                  <input
                    name="notice_period"
                    placeholder="Notice period in days"
                    className="common-input form-control"
                    required=""
                    type="number"
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        notice_period: e.target.value,
                      })
                    }
                    defaultValue={profileInput?.notice_period}
                  />
                  {errors?.notice_period !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.notice_period}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="yourself">
                    <span style={{ color: "red" }}>*</span>Tell us about
                    yourself
                  </label>
                  <textarea
                    className="common-textarea mt-10 form-control"
                    name="message"
                    placeholder="1. Years of Experience 
2. Professional Journey 
3. Interests 
4. Preferred Location and Work Mode"
                    //onFocus="this.placeholder = ''"
                    //onBlur="this.placeholder = 'Messege'"
                    required=""
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        about_yourself: e.target.value,
                      })
                    }
                    defaultValue={profileInput?.about_yourself}
                  />
                  {errors?.about_yourself !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.about_yourself}
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="Education" className="">
                        <span style={{ color: "red" }}>*</span>Highest Education
                        Qualification <br />
                        <br />
                        <br />
                        <sub></sub>
                      </label>
                      <select
                        id="highest_education"
                        className="form-control"
                        name="highest_education"
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            highest_education: e.target.value,
                          })
                        }
                        defaultValue={profileInput?.highest_education}
                      >
                        <option value="">Select Highest Education</option>
                        <option value="Below 10th">Below 10th</option>
                        <option value="10th">10th</option>
                        <option value="12th">12th</option>
                        <option value="Diploma">Diploma</option>
                        <option value="Graduation">Graduation</option>
                        <option value="Post Graduation">Post Graduation</option>
                        <option value="Doctorate">Doctorate</option>
                      </select>
                      {errors?.highest_education !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.highest_education}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="Education" className="">
                        Specialisation
                        <br />
                        <sub>
                          (Please specify the complete name/title of the highest
                          specialization you have completed or are currently
                          pursuing.)
                        </sub>
                      </label>
                      <input
                        name="name"
                        placeholder="Specialisation"
                        //onFocus="this.placeholder = ''"
                        //onBlur="this.placeholder = 'Enter your name'"
                        className="common-input form-control"
                        required=""
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            degree_name: e.target.value,
                          })
                        }
                        defaultValue={profileInput?.degree_name}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="Institution">
                    <span style={{ color: "red" }}>*</span>Name of Educational
                    Institution
                    <br />
                    <sub>
                      (Please provide the complete name of the institution where
                      you obtained your highest educational qualification. If
                      you are currently a student, enter the full name of your
                      current institution.)
                    </sub>
                  </label>
                  <input
                    name="name"
                    placeholder="Educational Institution"
                    //onFocus="this.placeholder = ''"
                    //onBlur="this.placeholder = 'Enter your name'"
                    className="common-input form-control"
                    required=""
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        institution_name: e.target.value,
                      })
                    }
                    defaultValue={profileInput?.institution_name}
                  />
                  {errors?.institution_name !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.institution_name}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="passing year" className="">
                    <span style={{ color: "red" }}>*</span>Year of
                    Completion/Graduation for Highest Education
                  </label>
                  <div className="row">
                    <div className="col-lg-6">
                      <select
                        id="month_of_passing"
                        className="form-control"
                        name="month_of_passing"
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            highest_education_passing_year: Number(
                              e.target.value
                            ),
                          })
                        }
                        defaultValue={
                          profileInput?.highest_education_passing_year
                        }
                      >
                        <option value="">Select Year</option>
                        {selectYearsOptions()}
                      </select>
                      {errors?.highest_education_passing_year !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.highest_education_passing_year}
                        </div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <select
                        onChange={(e) =>
                          setProfileInput({
                            ...profileInput,
                            highest_education_passing_month: Number(
                              e.target.value
                            ),
                          })
                        }
                        className="form-control"
                        name="experience_months"
                        defaultValue={
                          profileInput?.highest_education_passing_month
                        }
                      >
                        <option value="">Select Month</option>
                        <option value={1}>January</option>
                        <option value={2}>February</option>
                        <option value={3}>March</option>
                        <option value={4}>April</option>
                        <option value={5}>May</option>
                        <option value={6}>June</option>
                        <option value={7}>July</option>
                        <option value={8}>August</option>
                        <option value={9}>September</option>
                        <option value={10}>October</option>
                        <option value={11}>November</option>
                        <option value={12}>December</option>
                      </select>
                      {errors?.total_experience_months !== undefined && (
                        <div className="invalid-feedback d-block">
                          {errors?.total_experience_months}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="hear from" className="">
                    <span style={{ color: "red" }}>*</span>How did you learn
                    about us?
                  </label>

                  <select
                    className="form-control"
                    onChange={(e) =>
                      setProfileInput({
                        ...profileInput,
                        how_did_you_know: e.target.value,
                      })
                    }
                    defaultValue={profileInput?.how_did_you_know}
                  >
                    <option value="" hidden>
                      How did you learn about us?
                    </option>
                    <option value="Friend">Friend</option>
                    <option value="Referred">Referred</option>
                    <option value="Newspaper">Newspaper</option>
                    <option value="Facebook Advert">Facebook Advert</option>
                    <option value="Instagram Advert">Instagram Advert</option>
                    <option value="Linkedin Advert">Linkedin Advert</option>
                    <option value="Twitter Post">Twitter Post</option>
                    <option value="Social Media Story / Posts / Reel">
                      Social Media Story / Posts / Reel
                    </option>
                    <option value="Email Notification">
                      Email Notification
                    </option>
                    <option value="Whatsapp Forward Message">
                      Whatsapp Forward Message
                    </option>
                  </select>
                  {errors?.how_did_you_know !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.how_did_you_know}
                    </div>
                  )}
                </div>
                {/* <div className="form-group">
                  <input
                    type="checkbox"
                    id="primary-checkbox"
                    defaultChecked={true}
                  />
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book.
                  </p>
                </div> */}
                <button
                  type="submit"
                  className="primary-btn mt-20 text-white"
                  style={{ float: "right" }}
                >
                  Update
                </button>
                <div
                  className="mt-20 alert-msg"
                  style={{ textAlign: "left" }}
                />
              </div>
            </div>
          </form>
        </div>
      </AuthLayout>
    </Fragment>
  );
}
